import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Tooltip } from '@mui/material'
import DOMPurify from 'dompurify'
import useTooltipEnabled from 'Hooks/useTooltipEnabled'

interface PanoramaProps {
  panoramas?: any
  assetUrl?: string
}
const Panoramas = ({ panoramas, assetUrl }: PanoramaProps) => {
  const { locId } = useSelector((state: any) => state.location)
  const tooltipEnabled = useTooltipEnabled()

  return (
    <>
      {panoramas?.map((panorama: any) => {
        const accessibilityText = `${panorama.title + '.'} ${
              panorama.accessibility_description || panorama.description || ''
            }`
        return (
          <div
            tabIndex={0}
            aria-label={accessibilityText}
          >
            <h3 tabIndex={-1}>{panorama.title}</h3>
            <Box
              tabIndex={-1}
              component={'div'}
              sx={{
                width: '100%',
                maxHeight: '450px',
                background: '#f2f3f4',
                textAlign: 'center',
              }}
            >
              <Tooltip title={accessibilityText} placement='top' arrow disableHoverListener={!tooltipEnabled} disableFocusListener={!tooltipEnabled} disableTouchListener={!tooltipEnabled}>
              <Box
                tabIndex={-1}
                role='presentation'
                aria-role='presentation'
                sx={{ maxHeight: '450px', width: '100%' }}
                component={'img'}
                src={`${assetUrl}/media/${locId}/panoramas/${
                  panorama.id || panorama.hotspotMediaId || panorama.media_id
                }/1024.jpg`}
                alt={panorama.accessibility_description}
              />
              </Tooltip>
            </Box>
            <p
              tabIndex={-1}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(panorama.description, {
                  ADD_ATTR: ['target'],
                }),
              }}
            />
          </div>
        )
      })}
    </>
  )
}

export default Panoramas
